import React from "react";
import { ProviderIcon } from "../../shared/ProviderIcon";
import { analysisEngineLabel } from "./fanoutUtils";

export default function FanoutProviderFilter({
	analyses,
	activeAnalysis,
	onSelect,
	className = "",
}) {
	if (!analyses || analyses.length <= 1) return null;
	const label = (provider) => analysisEngineLabel(provider);

	return (
		<div
			className={`monitoring__segmented monitoring__segmented--sm monitoring__fanout-provider-filter ${className}`.trim()}
			role="group"
			aria-label="Provider"
		>
			{analyses.map((analysis) => (
				<button
					key={analysis.id}
					type="button"
					className={`monitoring__segmented-btn${
						activeAnalysis?.id === analysis.id ? " is-active" : ""
					}`}
					onClick={() => onSelect(analysis.provider)}
					aria-pressed={activeAnalysis?.id === analysis.id}
					title={label(analysis.provider)}
				>
					<ProviderIcon provider={analysis.provider} size={14} />
					<span className="monitoring__fanout-provider-filter-label">
						{label(analysis.provider)}
					</span>
				</button>
			))}
		</div>
	);
}
